import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;
const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export default function Login() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const res = await fetch(`${API_URL}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();
      if (data.success) {
        localStorage.setItem(
          "adminAuth",
          JSON.stringify({ v: true, exp: Date.now() + ONE_DAY_MS })
        );
        navigate("/ArticlesDashboard");
      } else {
        setErr(data.message || "Invalid password.");
      }
    } catch {
      setErr("Unable to reach the server. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <p className="eyebrow">Admin</p>
        <h1>Sign in.</h1>
        <p>Enter the admin password to manage content.</p>

        {err && <div className="login-error">{err}</div>}

        <form onSubmit={handleSubmit} className="admin-form">
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
            />
          </div>
          <button type="submit" className="btn-save" disabled={busy}>
            {busy ? "Signing in..." : "Sign In →"}
          </button>
        </form>
      </div>
    </div>
  );
}
